import SuggestionBox from './SuggestionBox';

export default SuggestionBox;
